/* Native details/forms/links work without this progressive enhancement. */
(() => {
  const closeMenus = (event) => {
    document.querySelectorAll('.sps-mobile-menu[open]').forEach((menu) => {
      if (event.type === 'keydown' && event.key === 'Escape') {
        menu.removeAttribute('open');
        menu.querySelector('summary')?.focus();
      } else if (event.type === 'click' && (!menu.contains(event.target) || event.target.closest('a'))) {
        menu.removeAttribute('open');
      }
    });
  };
  document.addEventListener('click', closeMenus);
  document.addEventListener('keydown', closeMenus);
})();

/* Colour image preview: preload, decode, then a fixed-layout 220ms crossfade. */
(() => {
  const pending = new WeakMap();
  const active = new WeakMap();
  const images = new Map();
  const loadImage = (url) => {
    if (images.has(url)) return images.get(url);
    const image = new Image();
    image.src = url;
    const ready = image.decode().then(() => image).catch((error) => {
      images.delete(url);
      throw error;
    });
    images.set(url, ready);
    return ready;
  };
  const reducedMotion = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;
  const stageFor = (image) => {
    if (image.parentElement.classList.contains('sps-colour-stage')) return image.parentElement;
    const stage = document.createElement('div');
    stage.className = 'sps-colour-stage';
    image.before(stage);
    stage.append(image);
    return stage;
  };
  const selectColour = async (button) => {
    const card = button.closest('[data-sps-colour-card]');
    const image = card?.querySelector('[data-sps-colour-image]');
    const label = card?.querySelector('[data-sps-colour-label]');
    const media = image?.closest('.sps-product-media');
    if (!card || !image || !label) return;
    const buyButton = card.querySelector('[data-sps-add]');
    if (buyButton) buyButton.disabled = true;
    const request = {};
    pending.set(card, request);
    media?.setAttribute('aria-busy', 'true');
    try {
      const next = await loadImage(button.dataset.imageUrl);
      // Finish an in-flight dissolve before starting another: rapid clicks never snap it.
      await active.get(card)?.done;
      if (pending.get(card) !== request || !card.isConnected) return;
      const changed = image.src !== next.src;
      const stage = stageFor(image);
      let outgoing;
      if (changed && !reducedMotion() && typeof stage.animate === 'function') {
        outgoing = document.createElement('div');
        outgoing.className = 'sps-colour-outgoing';
        outgoing.setAttribute('aria-hidden', 'true');
        const oldImage = image.cloneNode(true);
        oldImage.removeAttribute('data-sps-colour-image');
        oldImage.removeAttribute('id');
        oldImage.alt = '';
        oldImage.loading = 'eager';
        outgoing.append(oldImage);
        stage.append(outgoing);
      }
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = next.src;
      image.alt = `${button.dataset.colour} spark torch — colour preview`;
      // Intrinsic layout dimensions stay fixed across all five colour variants.
      card.querySelectorAll('[data-sps-swatch]').forEach((other) => {
        other.setAttribute('aria-pressed', String(other === button));
      });
      label.textContent = `Colour preview: ${button.dataset.colour}`;
      card.dataset.selectedColour = button.dataset.colour;
      if (outgoing) {
        const animation = outgoing.animate([{opacity:1},{opacity:0}], {
          duration:220, easing:'cubic-bezier(.22,1,.36,1)', fill:'forwards'
        });
        const transition = {};
        transition.done = animation.finished.catch(() => {}).finally(() => {
          outgoing.remove();
          if (active.get(card) === transition) active.delete(card);
        });
        active.set(card, transition);
      }
      card.dispatchEvent(new CustomEvent('sps:colour-preview', {bubbles:true, detail:{colour:button.dataset.colour}}));
    } catch {
      if (pending.get(card) === request) label.textContent = 'Image could not load. Please try this colour again.';
    } finally {
      if (pending.get(card) === request) {
        media?.removeAttribute('aria-busy');
        const select = card.querySelector('[data-sps-variant]');
        const option = [...(select?.options || [])].find((o) => o.dataset.colour === card.dataset.selectedColour);
        if (option) select.value = option.value;
        if (buyButton) buyButton.disabled = !option || option.dataset.available !== 'true';
      }
    }
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-sps-swatch]');
    if (button) selectColour(button);
  });
  document.addEventListener('keydown', (event) => {
    const button = event.target.closest('[data-sps-swatch]');
    if (!button || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    event.preventDefault();
    const buttons = [...button.closest('.sps-colour-picker').querySelectorAll('[data-sps-swatch]')];
    const index = buttons.indexOf(button);
    const nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
    buttons[nextIndex].focus();
    selectColour(buttons[nextIndex]);
  });
  const warmButton = (event) => {
    const button = event.target.closest('[data-sps-swatch]');
    if (button) loadImage(button.dataset.imageUrl).catch(() => {});
  };
  document.addEventListener('pointerover', warmButton);
  document.addEventListener('focusin', warmButton);
  const observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.querySelectorAll('[data-sps-swatch]').forEach((button) => {
        loadImage(button.dataset.imageUrl).catch(() => {});
      });
      observer.unobserve(entry.target);
    });
  }, {rootMargin:'300px'}) : null;
  const warmCards = (root) => root.querySelectorAll('[data-sps-colour-card]').forEach((card) => observer?.observe(card));
  warmCards(document);
  document.addEventListener('shopify:section:load', (event) => warmCards(event.target));
})();

/* Real Shopify variant selection shares the existing colour transition. */
document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-sps-variant]')) return;
  const card = event.target.closest('[data-sps-colour-card]');
  const colour = event.target.selectedOptions[0]?.dataset.colour;
  const swatch = [...card.querySelectorAll('[data-sps-swatch]')].find((b) => b.dataset.colour === colour);
  swatch?.click();
});
document.addEventListener('submit', (event) => {
  if (!event.target.matches('.sps-buy-form')) return;
  const button = event.target.querySelector('[data-sps-add]');
  if (button.disabled) { event.preventDefault(); return; }
  button.disabled = true;
  button.textContent = 'Opening checkout…';
});
window.addEventListener('pageshow', () => {
  document.querySelectorAll('[data-sps-add]').forEach((button) => {
    const option = button.form.querySelector('[data-sps-variant]')?.selectedOptions[0];
    button.disabled = option?.dataset.available !== 'true';
    button.textContent = button.disabled ? 'Sold out' : 'Buy now ↗';
  });
});

/* Official Shopify cart permalinks go directly to checkout, never back home. */
document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-sps-checkout-colour]')) return;
  const root = event.target.closest('[data-sps-quick-checkout]');
  const id = event.target.value;
  if (!/^\d+$/.test(id)) return;
  root.querySelectorAll('[data-sps-checkout-link]').forEach((link) => {
    const url = new URL(link.href);
    url.pathname = url.pathname.replace(/\/\d+:1$/, '/' + id + ':1');
    link.href = url.href;
  });
  const colour = event.target.selectedOptions[0].textContent.trim();
  const image = root.querySelector('[data-sps-checkout-image]');
  if (image) {
    const path = image.dataset['colour' + colour];
    if (path) image.src = path;
    image.alt = colour + ' spark torch — colour preview';
  }
  const card = root.closest('[data-sps-colour-card]');
  const swatch = [...(card?.querySelectorAll('[data-sps-swatch]') || [])].find((b) => b.dataset.colour === colour);
  if (swatch?.getAttribute('aria-pressed') !== 'true') swatch?.click();
});
document.addEventListener('sps:colour-preview', (event) => {
  const select = event.target.querySelector('[data-sps-checkout-colour]');
  if (!select) return;
  const option = [...select.options].find((o) => o.textContent.trim() === event.detail.colour);
  if (option && select.value !== option.value) {
    select.value = option.value;
    select.dispatchEvent(new Event('change', {bubbles:true}));
  }
});

/* Progressive enhancement: tactile finish cards instead of OS select menus. */
(() => {
  const palette = {silver:'#c9cbd0',olive:'#626c51',black:'#252527',pink:'#e8aec4',yellow:'#dfb54e'};
  const pickers = new WeakMap();
  const sync = (select) => {
    const picker = pickers.get(select);
    if (!picker) return;
    const selected = select.selectedOptions[0];
    picker.querySelector('[data-sps-finish-name]').textContent = selected?.textContent.replace(/ — Sold out$/, '').trim() || '';
    picker.querySelectorAll('[data-sps-finish]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.spsFinish === select.value));
      button.disabled = [...select.options].find((o) => o.value === button.dataset.spsFinish)?.disabled === true;
    });
  };
  const init = (root) => root.querySelectorAll('[data-sps-checkout-colour], [data-sps-variant]').forEach((select) => {
    if (pickers.has(select)) return;
    const picker = document.createElement('div');
    picker.className = 'sps-finish-picker';
    const caption = document.createElement('div');
    caption.className = 'sps-finish-caption';
    const label = document.createElement('span');
    label.textContent = 'Choose your finish';
    const name = document.createElement('span');
    name.setAttribute('data-sps-finish-name', '');
    caption.append(label, name);
    const options = document.createElement('div');
    options.className = 'sps-finish-options';
    options.setAttribute('role', 'group');
    options.setAttribute('aria-label', 'Choose your finish');
    [...select.options].forEach((option) => {
      const colour = (option.dataset.colour || option.textContent).replace(/ — Sold out$/, '').trim();
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'sps-finish-option';
      button.dataset.spsFinish = option.value;
      button.setAttribute('aria-label', colour + (option.disabled ? ' — Sold out' : ''));
      button.title = colour;
      const dot = document.createElement('span');
      dot.className = 'sps-finish-dot';
      dot.style.setProperty('--finish-colour', palette[colour.toLowerCase()] || '#999');
      dot.setAttribute('aria-hidden', 'true');
      const text = document.createElement('span');
      text.className = 'sps-finish-text';
      text.textContent = colour;
      button.append(dot, text);
      button.addEventListener('click', () => {
        if (button.disabled) return;
        select.value = option.value;
        select.dispatchEvent(new Event('change', {bubbles:true}));
        sync(select);
      });
      options.append(button);
    });
    picker.append(caption, options);
    select.after(picker);
    pickers.set(select, picker);
    select.classList.add('sps-colour-native');
    select.hidden = true;
    select.labels?.forEach((label) => { label.hidden = true; });
    select.addEventListener('change', () => sync(select));
    sync(select);
  });
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('sps:colour-preview', (event) => {
    const select = event.target.querySelector('[data-sps-variant], [data-sps-checkout-colour]');
    if (!select) return;
    const option = [...select.options].find((o) => (o.dataset.colour || o.textContent).trim() === event.detail.colour);
    if (option) select.value = option.value;
    sync(select);
  });
  window.addEventListener('pageshow', () => document.querySelectorAll('.sps-colour-native').forEach(sync));
})();
